import auth from '@core/services/auth';
import request from '@core/services/request';

import { accountingAPI } from './api.accounting';
import { addressAPI } from './api.address';
import { apiTransactionsAPI } from './api.apiTransactions';
import { applicationsAPI } from './api.applications';
import { associationsAPI } from './api.associations';
import { autoCompleteAPI } from './api.autoComplete';
import { azureMediaServicesAPI } from './api.azureMediaServices';
import { azureOcrAPI } from './api.azureOcr';
import { cancelCoverageAPI } from './api.cancelCoverage';
import { carFaxAPI } from './api.carFax';
import { cbcAPI } from './api.cbc';
import { checklistAPI } from './api.checklist';
import { creditReportAPI } from './api.creditReport';
import { customerPortalAPI } from './api.customerPortal';
import { customersAPI } from './api.customers';
import { dartAPI } from './api.dart';
import { dataDefinitionsAPI } from './api.dataDefinitions';
import { documentsAPI } from './api.documents';
import { dywAPI } from './api.dataYourWay';
import { fimenuAPI } from './api.fimenu';
import { financeChannelsAPI } from './api.financeChannels';
import { internalRatingAPI } from './api.internalRating';
import { lendersAPI } from './api.lenders';
import { marketScanAPI } from './api.marketScan';
import { meetingAPI } from './api.meeting';
import { oauthAPI } from './api.oauth';
import { plaidAPI } from './api.plaid';
import { plateTransactionsAPI } from './api.plateTransactions';
import { redirectAPI } from './api.redirect';
import { reportsAPI } from './api.reports';
import { routeOneAPI } from './api.routeOne';
import { saturnBrowserAPI } from './api.saturnBrowser';
import { serviceLookupAPI } from './api.serviceLookup';
import { settingsAPI } from './api.settings';
import { spireonAPI } from './api.spireon';
import { usersAPI } from './api.users';
import { utilitiesAPI } from './api.utilities';
import { vehicleAPI } from './api.vehicle';
import { videosAPI } from './api.videos';

import { DataModel } from '@core/classes/SharedEnums';

export const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;
export const TWELVE_HOURS = 1000 * 60 * 60 * 12;

export const getSaturnGetRequest = (reqData: any, overridesModel: any = null, modelType = DataModel.Settings) => {
	return { reqData, overridesModel, modelType };
};

export const getSettingsData = (data: any, route: any, refresh = false, overridesModel: any = null) => {
	if (!refresh) {
		return new Promise<any>(resolve => resolve({ data }));
	}

	return request.post(route, getSaturnGetRequest(data, overridesModel));
};

//cache
export const $cache: {
	lookups?: any;
	settings?: any;
	settingsExpiration?: any;
	init?: any;
} = {
	lookups: null,
	settingsExpiration: null,
	init: (lookups: any) => {
		const currMillisecond = new Date().getMilliseconds();
		$cache.lookups = lookups;
		$cache.settingsExpiration = currMillisecond + 1000 * 60 * 60 * 24; // expires in 24 hours - we dont use this
	},
};

const api = {
	//general API calls
	cancel: (tokenId: any) => request.cancel(tokenId),
	ping: () => request.get('/Ping'),
	getVersion: () => request.get('/Version'),
	testDate: () => request.get('/TestDate'),
	generateError: () => request.get('/GenerateError'),
	getAuthUserDataTest: () => request.get('/userdata'),
	getLookups: () => new Promise(resolve => resolve($cache.settings)),
	broadcastSignalRMessage: (message: any) => request.postSpecial('/SignalR/BroadcastMessage', message),

	//Saturn API calls
	getOrInitializeDeal: (dealNumber: any, storeCode: any) =>
		request.post(`/Deal/GetOrInitializeDeal`, {
			dealNumber: dealNumber,
			storeCode: storeCode,
			user: auth.getTokenPayload().EmployeeCode,
		}),

	exploreInfo: (styleId: any) =>
		request.get(`/Lookup/GetExploreInfo/` + styleId, {
			cache: true,
			maxAge: TWENTY_FOUR_HOURS,
		}),
	zipLookup: (zip: any) =>
		request.get(`/Lookup/DecodeZip/` + zip.substring(0, 5), {
			cache: true,
			maxAge: TWENTY_FOUR_HOURS,
		}),
	getZipcodeDetails: (zipCode: any) => request.get(`/Lookup/Zipcode/` + zipCode),
	getCountryDetails: () => request.get(`/Lookup/GetCountryDetails/`),

	//getUSWarrantyRates: (fimenu) => {
	//    return request.post(`/RateUSWarranty`, fimenu)
	//},
	//getNSDPaperwork: (fimenu) => {
	//    return request.post(`/ContractNSD/Paint`, fimenu)
	//},
	//getUSWPaperwork: (fimenu) => {
	//    return request.post(`/USWarranty/Contract`, fimenu)
	//},

	vehicle: vehicleAPI,
	settings: settingsAPI,
	carFax: carFaxAPI,
	cbc: cbcAPI,
	creditreport: creditReportAPI,
	routeOne: routeOneAPI,
	lenders: lendersAPI,
	financeChannels: financeChannelsAPI,
	marketScan: marketScanAPI,
	reports: reportsAPI,
	utilities: utilitiesAPI,
	internalRating: internalRatingAPI,
	users: usersAPI,
	meeting: meetingAPI,
	dart: dartAPI,
	dataYourWay: dywAPI,
	//F&I Menu API calls
	fimenu: fimenuAPI,
	// API CALLS FOR DDI TECHNOLOGIES
	plateTransactions: plateTransactionsAPI,
	// API CALLS FOR SPIREON(LOJACK GPS) or KAHU
	spireon: spireonAPI,
	applications: applicationsAPI,
	customerPortal: customerPortalAPI,
	customers: customersAPI,
	cancelCoverage: cancelCoverageAPI,
	videos: videosAPI,
	azureMediaServices: azureMediaServicesAPI,
	plaid: plaidAPI,
	documents: documentsAPI,
	checklist: checklistAPI,
	saturnBrowser: saturnBrowserAPI,
	redirect: redirectAPI,
	azureOcr: azureOcrAPI,
	associations: associationsAPI,
	autoComplete: autoCompleteAPI,
	address: addressAPI,
	serviceLookup: serviceLookupAPI,
	oauth: oauthAPI,
	dataDefinitions: dataDefinitionsAPI,
	apiTransactions: apiTransactionsAPI,
	accounting: accountingAPI,
};

export default api;
